import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { deofuscate, ofuscate } from '@/utils/obfuscation';
import { Breadcrumbs } from '@/shared/breadcrum/breadcrum.component';
import { Variant } from '@/interfaces/transaction-result';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css']
})
export class ResultComponent implements OnInit {


  constructor(
    private route: ActivatedRoute,
  ) { }

  email: string = '';
  id: number = 0;
  variant: Variant = 'success';
  message: string = '';
  messageBold: string = '';
  subtitle: string = 'La licencia en zona mina ha sido actualizada correctamente';

  actionButtonText: string = '';
  actionButtonPath: string = '';

  ofuscatedData: string = '';

  breadcrums: Breadcrumbs = [
    { text: 'Inicio', path: '/dashboard' },

  ]

  ngOnInit() {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      this.email = params.email || '';
      this.id = params.id || '';
      this.variant = params.variant || 'success';
      if (this.variant === 'success') {
        this.message = `Una copia de su solicitud fue enviada al correo electrónico ${this.email}`;
        this.actionButtonText = 'Ver detalle de la licencia';
        this.messageBold = `N° solicitud: ${this.id}`;
        const licenseLinkParams = ofuscate({ id: params.licenseId, variant: 'LICENSE' });
        this.actionButtonPath = `/license/show/${licenseLinkParams}`;
      }
      if (this.variant === 'failure') {
        this.actionButtonText = 'Volver';
        this.actionButtonPath = '/license/mine/update';
        this.subtitle = 'Hubo un problema y no hemos podido actualizar la solicitud. Por favor intenta de nuevo.';
      }
    });
  }

}
